import { defineStore } from "pinia";

import {
  ACTION_PROFILE_INIT,
  ACTION_ADMIN_FOLDER_INIT,
  ACTION_ACCOUNT_INIT,
  ACTION_PROFILE_GET_SUBSCRIPTION_STATUS,
  GETTER_PROFILE_GET_SUBSCRIPTION_STATUS,
  GETTER_PROFILE_GET,
  GETTER_ADMIN_FOLDER_GET,
  GETTER_PROFILE_GET_ACCOUNT,
} from "@etab/stores/types";
import { EtabProfileService, EtabAccountService } from "@core/services";
import { EtabProfileModel, AccountModel, EtabAdminFolderModel } from "@core/models";

export const useProfileStore = defineStore("profile", {
  // convert to a function
  state: () => ({
    profile: {},
    account: {},
    adminFolder: {},
    subscriptionStatus: "",
  }),
  getters: {
    [GETTER_PROFILE_GET]: (state) => new EtabProfileModel(state.profile),
    [GETTER_ADMIN_FOLDER_GET]: (state) => new EtabAdminFolderModel(state.adminFolder),
    [GETTER_PROFILE_GET_ACCOUNT]: (state) => new AccountModel(state.account),
    [GETTER_PROFILE_GET_SUBSCRIPTION_STATUS]: (state) => state.subscriptionStatus,
  },
  actions: {
    async [ACTION_PROFILE_INIT]() {
      const data = await EtabProfileService.get();
      if (data) {
        this.profile = data;
      }
    },
    async [ACTION_ADMIN_FOLDER_INIT]() {
      const data = await EtabAccountService.getEtabAdminFolderInfos();
      if (data) {
        this.adminFolder = data;
      }
    },
    async [ACTION_ACCOUNT_INIT]() {
      const data = await EtabAccountService.get();
      if (data) {
        this.account = data;
      }
    },
    async [ACTION_PROFILE_GET_SUBSCRIPTION_STATUS]() {
      const status = await EtabProfileService.getSubscriptionStatus();
      this.subscriptionStatus = status;
      return status;
    },
    // easily reset state using `$reset`
    clearProfileStore() {
      this.$reset();
    },
  },
});
